import { ReactNode, JSX } from "react"

/**
 * Renders a single labelled field in an HPC job details panel: a small muted
 * label above its value. Shared by the job logs page and the array job page so
 * both detail panels read identically.
 *
 * @param props - Component props.
 * @param props.label - The field label shown above the value.
 * @param props.className - Optional extra classes, used for grid spanning.
 * @param props.children - The field value content.
 * @returns The labelled field element.
 */
export function DetailField({
  label,
  className,
  children,
}: {
  label: string
  className?: string
  children: ReactNode
}): JSX.Element {
  return (
    <div className={className}>
      <p className="text-xs font-medium text-muted-foreground mb-0.5">{label}</p>
      <div className="text-sm min-w-0 break-words">{children}</div>
    </div>
  )
}
